/** The access window for one purchased plan, exactly as the customer should read it.
 *  Display only — nothing here gates access. Dates come from the server (purchase date + 12 months).
 */
const day = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export const AccessDates = ({ access, slug, className = "" }) => {
  if (!access) return null;
  const purchased = day(access.purchased_at);
  const until = day(access.web_access_until);
  return (
    <dl
      data-testid={`access-dates-${slug}`}
      className={`space-y-1 text-[12.5px] leading-relaxed text-brand-tealSoft ${className}`}
    >
      {purchased && (
        <div className="flex gap-1.5">
          <dt className="text-muted-foreground">Purchased:</dt>
          <dd data-testid={`access-purchased-${slug}`} className="font-semibold">{purchased}</dd>
        </div>
      )}
      {until && (
        <div className="flex gap-1.5">
          <dt className="text-muted-foreground">Web access:</dt>
          <dd data-testid={`access-web-${slug}`} className="font-semibold">Until {until}</dd>
        </div>
      )}
      <div className="flex gap-1.5">
        <dt className="text-muted-foreground">PDF access:</dt>
        <dd data-testid={`access-pdf-${slug}`} className="font-semibold">Never expires</dd>
      </div>
    </dl>
  );
};
